import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import type { LocaleDescription } from '@/services/apis/wallet/type'

export type CommonTranslationFuncType = (key: string, args: LocaleDescription['localeArgs']) => string

/**
 *
 * 前后端公共模块翻译
 */
export const useCommonTranslation = () => {
  const { t } = useTranslation('common')

  const ct: CommonTranslationFuncType = useCallback(
    (key, args) => {
      /** 有可能存在没有key的情况，因此这里需要做一下兼容 */
      const obj = args?.reduce((acc, cur) => {
        const key = cur.name
        acc[key] = cur.value || ''
        return acc
      }, {})
      return t(key, obj)
    },
    [t]
  )

  return {
    ct,
  }
}
